import { chooseDefinition } from '@platform/core/lib/chooseDefinition';
import type { IModuleDefinitionState } from '@platform/core/types/modularity/IModuleDefinitionState';
import { isOfflineError } from '@platform/modularity/isOfflineError';
import { findModuleDefinition } from '@platform/modularity/moduleDefinitionRegistry';
import { useModuleDefinition } from '@platform/modularity/useModuleDefinition';
import { useGetModuleQuery } from '@platform/state/api';

/**
 * Визначення модуля для сторінок «Налаштування» за рівнем (ADR-027): простір — злите з налаштуваннями простору маршруту (useModuleDefinition);
 * «Глобально» — глобальне визначення, яке успадковує кожен простір без власного налаштування (опубліковане → глобальне: GET
 * /meta/modules/{ключ} без простору); файли пакета (опубліковане) — миттєвий fallback, доки сервер відповідає чи коли він недоступний.
 */
export function useScopeDefinition(moduleKey: string, global: boolean): IModuleDefinitionState {
  const workspace = useModuleDefinition(global ? '' : moduleKey);
  const query = useGetModuleQuery({ key: moduleKey }, { skip: !global || !moduleKey });
  if (!global) return workspace;
  const pending = query.isLoading || query.isFetching;
  const fallback = pending || isOfflineError(query.error) ? findModuleDefinition(moduleKey) : undefined;
  return chooseDefinition({ data: query.currentData, isLoading: pending, error: query.currentData || pending ? undefined : query.error }, fallback);
}
